/**
 * Router — geschuetzte Bereiche + Login. Hash-History (kein Server-Rewrite noetig
 * neben Caddys SPA-Fallback, robust auch beim direkten Aufruf).
 */

import { createRouter, createWebHashHistory } from 'vue-router';
import { useAuthStore } from '@core/auth/auth.store';

const routes = [
  { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue'), meta: { oeffentlich: true } },
  { path: '/', name: 'buchungen', component: () => import('@/views/BuchungenView.vue') },
  { path: '/erfassen', name: 'erfassen', component: () => import('@/views/ErfassenView.vue') },
  { path: '/einstellungen', name: 'einstellungen', component: () => import('@/views/EinstellungenView.vue') },
  { path: '/passwort-aendern', name: 'passwort-aendern', component: () => import('@/views/PasswortAendernView.vue') },
  { path: '/:pfad(.*)*', redirect: '/' },
];

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to) => {
  const auth = useAuthStore();
  if (!to.meta.oeffentlich && !auth.isLoggedIn) {
    return { name: 'login', query: { weiter: to.fullPath } };
  }
  // Startpasswort aktiv -> erst das eigene Passwort setzen, dann die App.
  // (Der Server sperrt parallel alle Fach-Endpunkte, das hier ist die UX-Seite.)
  if (auth.isLoggedIn && auth.mussPasswortAendern && to.name !== 'passwort-aendern') {
    return { name: 'passwort-aendern' };
  }
  if (to.name === 'login' && auth.isLoggedIn) {
    return { name: 'buchungen' };
  }
});
